import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFeature } from '../../contexts/EntitlementsContext';
import UsageMeter from './UsageMeter';

// Drop into PageHeader's `meter` slot to show this page's own plan limit in
// place — "3/20 invoices issued this month" right on the Invoices page —
// instead of sending the admin to the Subscription page to check. Silent
// (renders nothing) until the entitlements snapshot is ready, for a company
// with no subscription, or for a feature this plan doesn't track at all —
// the same "server is the judge" rule FeatureGate follows, so it never
// implies a limit that doesn't apply.
//
// `helpId` (step 9, default `plan-limit.<feature>`): every plan usage meter
// gets a filled HelpMark reading the same live numbers via the shared
// plan-limit template (see components/help/planLimitContent.js) — pass
// `helpId={false}` to opt a specific meter out entirely.
const FeatureUsageMeter = ({ feature, label, helpId }) => {
  const { t } = useTranslation();
  const { allowed, usage, status } = useFeature(feature);
  if (status !== 'ready' && status !== 'refreshing') return null;
  if (!allowed || !usage || usage.used == null) return null;
  const resolvedHelpId = helpId === false ? null : (helpId || `plan-limit.${feature}`);
  return (
    <UsageMeter
      label={label}
      usage={usage}
      unlimitedLabel={t('unlimited', { defaultValue: 'unlimited' })}
      compact
      helpId={resolvedHelpId}
    />
  );
};

export default FeatureUsageMeter;
